<template>
    <app-modal
        modal-id="attendance-import-modal"
        modal-size="large"
        modal-alignment="top"
        @close-modal="closeModal"
    >
        <template slot="header">
            <h5 class="modal-title">{{ $t('import_attendance') }}</h5>
            <button type="button" class="close outline-none" @click="closeModal">
                <span>
                    <app-icon name="x"></app-icon>
                </span>
            </button>
        </template>

        <template slot="body">
            <import-attendances @import-success="handleImportSuccess"/>
        </template>
    </app-modal>
</template>

<script>
import ImportAttendances from "../Setting/Import/ImportAttendances";

export default {
    name: "AttendanceImportModal",
    components: {ImportAttendances},
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        closeModal() {
            $('#attendance-import-modal').modal('hide');
            this.$emit('input', false);
            this.$emit('close');
        },
        handleImportSuccess() {
            this.$emit('import-complete');
            this.$hub.$emit('reload-summary');
        }
    }
};
</script>
